let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3fp4P")).then(() => parcelRequire('emAAV'));